export default __webpack_public_path__ + "static/media/0186.0e9c1e19.jpg";